import * as React from 'react'
import { ReactElement } from 'react'
import { Route, RouteComponentProps } from 'react-router'
import GlobalTaskOverview from './Task/GlobalTaskOverview'
import TaskOverview from './Task/TaskOverview'
import EntityPage, { EntityPageProps, ParentProps } from './EntityPage'
import { MenuItemKey } from '../components/MainMenu'

export const workflowBaseUrl = '/workflow'

/** The workflow variant of {@link Tasks}; same overview, same add/edit dialog (HAM-4275). */
export default function Workflows(props: EntityPageProps): ReactElement {
    return (
        <EntityPage {...props} baseUrl={workflowBaseUrl}>
            {({ route, baseUrl }: ParentProps) => (
                <Route
                    path={[`${route}/:id/:action(edit)`, `${route}/:action(add)`, route]}
                    render={(routeProps: RouteComponentProps) =>
                        props.currentFile === undefined && props.currentCRMRelation === undefined ? (
                            <GlobalTaskOverview baseUrl={baseUrl} breadcrumb={MenuItemKey.Workflow} />
                        ) : (
                            <TaskOverview
                                {...routeProps}
                                {...props}
                                fileId={props.currentFile?.id}
                                crmRelationId={props.currentCRMRelation?.id}
                                baseUrl={baseUrl}
                                localStorageKeyPrefix={`HammockTaskOverview-${props.currentFile?.id || props.currentCRMRelation?.id}-`}
                            />
                        )
                    }
                />
            )}
        </EntityPage>
    )
}
